module.exports = __webpack_public_path__ + "img/icon-dexpoint.036cdab3.svg";